import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from 'react-hot-toast';
import {
  FaRegEnvelope,
  FaRegMap,
} from "react-icons/fa";
import { BsTelephone } from "react-icons/bs";
import { IoPaperPlane } from "react-icons/io5";
import { ReactComponent as Curve } from "../assets/curve_right.svg";

const EMAILJS_PUBLIC_KEY = 'rcbOYE2V2KyPMsUHR'
const EMAILJS_SERVICE_ID = 'service_0khfofa'
const EMAILJS_TEMPLATE_ID = 'template_xg34z7w'

const Contact = () => {
  const form = useRef();
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        form.current,
        EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success('Message sent successfully! I\'ll get back to you soon.', {
            duration: 4000,
            position: 'bottom-center',
          });
          //Clearing form fields
          setFormValues({
            name: "",
            email: "",
            subject: "",
            message: "",
          });
        },
        (error) => {
          console.log(error.text);
          toast.error('Failed to send message. Please try again.', {
            duration: 4000,
            position: 'bottom-center',
          });
        }
      );
  };

  return (
    <section className="section-bg-b2 section" id="contact">
      <Toaster />
      <div className="container flex flex-col lg:flex-row gap-10 lg:gap-[250px] relative px-2 lg:px-16">

        {/* Left Column: Title, Subtitle, Info Card */}
        <div className="w-full lg:w-[30%] ">
          <div className="mb-10 text-center lg:text-left">
            <h2 className="text-[clamp(1.75rem,_1.5rem_+_1.5vw,_2.5rem)] font-bold text-title mb-[15px] relative inline-block tracking-wider">
              Let's Connect
            </h2>
            <p className="text-normal font-body leading-relaxed text-text opacity-80">
              Let’s collaborate to turn ideas into impactful digital experiences. Whether it’s building a product or solving a problem, I’d love to work together
            </p>
          </div>

          <div className="bg-container rounded-[40px] p-3 max-w-[400px] mx-auto ] flex flex-col gap-3 hover:border-primary/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <div className="flex items-center gap-5 group">
              <span className="w-14 h-14 rounded-[18px] bg-primary/10 text-primary grid place-items-center text-2xl transition-transform duration-300 group-hover:scale-110 shrink-0">
                <FaRegEnvelope />
              </span>
              <div className="overflow-hidden">
                <h3 className="text-lg font-bold mb-1">Email</h3>
                <p className="text-sm text-text opacity-90 break-words">harshalrajput9000@gmail.com</p>
              </div>
            </div>

            <div className="flex items-center gap-5 group">
              <span className="w-14 h-14 rounded-[18px] bg-primary/10 text-primary grid place-items-center text-2xl transition-transform duration-300 group-hover:scale-110 shrink-0">
                <BsTelephone />
              </span>
              <div>
                <h3 className="text-lg font-bold mb-1">Phone</h3>
                <p className="text-sm text-text opacity-90">+91 8826639815</p>
              </div>
            </div>

            <div className="flex items-center gap-5 group">
              <span className="w-14 h-14 rounded-[18px] bg-primary/10 text-primary grid place-items-center text-2xl transition-transform duration-300 group-hover:scale-110 shrink-0">
                <FaRegMap />
              </span>
              <div>
                <h3 className="text-lg font-bold mb-1">Location</h3>
                <p className="text-sm text-text opacity-90">Ghaziabad, UP, India</p>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Curve Arrow */}
        <div className="hidden lg:block absolute left-[34%] top-[25%] z-10 opacity-60 text-primary pointer-events-none">
          <Curve className="w-[20vw] h-[20vw] fill-current rotate-6" />
        </div>

        {/* Right Column: Contact Form */}
        <div className="w-full lg:w-[45%] max-w-[600px] mx-auto lg:ml-auto lg:mr-0">
          <div className="bg-container   rounded-[40px] px-4 py-7 lg:px-6 ] hover:border-primary/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <form className="flex flex-col gap-5 " ref={form} onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-[4fr_6fr] gap-5">
                <div className="grid gap-1">
                  <label className="text-sm font-bold uppercase tracking-wider ml-2">
                    Full Name <b className="text-primary">*</b>
                  </label>
                  <input
                    type="text"
                    name="name"
                    onChange={handleChange}
                    value={formValues.name}
                    className="text-title h-[40px] rounded-[30px] px-4 border border-solid border-border"
                  />
                </div>
                <div className="grid gap-1">
                  <label className="text-sm font-bold uppercase tracking-wider ml-2">
                    Email Address <b className="text-primary">*</b>
                  </label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange}
                    value={formValues.email}
                    className="text-title h-[40px] rounded-[30px] px-4 border border-solid border-border"
                  />
                </div>
              </div>

              <div className="grid gap-1">
                <label className="text-sm font-bold uppercase tracking-wider ml-2">
                  Subject <b className="text-primary">*</b>
                </label>
                <input
                  type="text"
                  name="subject"
                  onChange={handleChange}
                  value={formValues.subject}
                  className="text-title h-[40px] rounded-[30px] px-4 border border-solid border-border"
                />
              </div>

              <div className="grid gap-1">
                <label className="text-sm font-bold uppercase tracking-wider ml-2">
                  Message <b className="text-primary">*</b>
                </label>
                <textarea
                  name="message"
                  onChange={handleChange}
                  value={formValues.message}
                  className="text-title h-[115px] rounded-[30px] px-4 py-3 resize-none border border-solid border-border"
                ></textarea>
              </div>

              <div className="flex items-center justify-end gap-4">
                <p className="text-sm opacity-80 text-right">* You can expect a response within 24–48 hours.</p>
                <button type="submit" className="btn !h-[50px] !px-6 inline-flex items-center gap-2 text-cs shrink-0 ">
                  Send <IoPaperPlane className="text-lg" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
